import type { ResolveFn } from '@angular/router';

// TODO: T310844 remove this resolver
export const PostJobPageTitleResolver: ResolveFn<string> = (route, state) => {
  return `Post a job`;
};
